/**
 * Skip to Main Content Component
 * 
 * Provides a skip link for keyboard users to bypass navigation
 * and jump directly to main content. Required for WCAG 2.1 Level AA.
 */

import React from 'react';

export interface SkipToMainProps {
  mainContentId?: string;
}

export const SkipToMain: React.FC<SkipToMainProps> = ({ mainContentId = 'main-content' }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const mainContent = document.getElementById(mainContentId);
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a
      href={`#${mainContentId}`}
      className="skip-to-main"
      onClick={handleClick}
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
};
